export class RegisterForTrainingEventRequest {

    LicenseID: number;
    TrainingEventID: number;
    AlternateEmail: string;
    AlternatePhone: string;

}